<template>
  <MatchHeroBanner
    :hero-image="heroData.heroImage"
    :mobile-hero-image="heroData.heroImageWap"
    :alt="heroData.alt"
  />
</template>

<script>
import MatchHeroBanner from '@/components/match/home/MatchHeroBanner.vue'

export default {
  name: 'MatchDetailHeroSection',
  components: { MatchHeroBanner },
  props: {
    heroData: { type: Object, required: true },
  },
}
</script>
